var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectAll)?_c('span',[_vm._v(_vm._s(_vm.selectAll))]):_c('priority-dot',{attrs:{"priority-level":_vm.numericValue,"priority":_vm.objectValue,"show-label":""}})}
var staticRenderFns = []

export { render, staticRenderFns }